// DS: DS6.1.1
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React from 'react';
import c from 'classnames';
import BiDiv from '@wix/da-bi/pkg/Components/BiDiv';
import s from './ListHeader.scss';
const ListHeader = (_param)=>{
    var { children, withDivider, className } = _param, rest = _object_without_properties(_param, [
        "children",
        "withDivider",
        "className"
    ]);
    return /*#__PURE__*/ React.createElement(BiDiv, _object_spread({
        className: c(s['root'], className)
    }, rest), /*#__PURE__*/ React.createElement("div", {
        className: c(children && s['has-content'], withDivider && s['has-divider'])
    }, children));
};
ListHeader.displayName = 'ListHeader';
export default ListHeader;

//# sourceMappingURL=ListHeader.js.map